export function unwrapApiData<T>(response: unknown, fallback: T): T {
  if (response && typeof response === 'object' && 'data' in response) {
    const data = (response as { data?: unknown }).data;
    return data === undefined || data === null ? fallback : (data as T);
  }

  return response === undefined || response === null ? fallback : (response as T);
}

export function unwrapApiArray<T>(response: unknown): T[] {
  const data = unwrapApiData<unknown>(response, []);
  return Array.isArray(data) ? data as T[] : [];
}
